import { render, staticRenderFns } from "./FormSelectStandard.vue?vue&type=template&id=6e973a25"
import script from "./FormSelectStandard.vue?vue&type=script&lang=js"
export * from "./FormSelectStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports